import React, { Suspense, lazy } from "react";
import styles from "./impression.css";
import { Helmet } from "react-helmet";

const LogoImpression = lazy(() => import("../Logos/logoImpression"));
const ImpressionMain = lazy(() => import("./impressionMain"));
const ImpressionBottom = lazy(() => import("./impressionBottom"));
const ImpressionHeader = lazy(() => import("./impressionHeader"));

const Impression = () => {
  return (
    <div className={styles.bigContainer}>
      <Helmet>
        <title>Éric Fayolle | Impression</title>
        <meta
          name="description"
          content="Page d'impression d'Éric Fayolle. Le processus photographique est composé de deux moments de création à part entière : la prise de vue et le tirage. Le regard, l’intention de la prise de vue se réalisent et s’expriment lors du tirage."
        />
        <meta name="keywords" cpntent="impression,photo,art,eric,fayolle" />
      </Helmet>
      <LogoImpression />
      <ImpressionHeader />
      <Suspense fallback={<></>}>
        <ImpressionMain />
      </Suspense>
      <Suspense fallback={<></>}>
        <ImpressionBottom />
      </Suspense>
    </div>
  );
};

export default Impression;
